import React, { useContext, useEffect } from 'react';
import LoginFooter from '../../components/Footers/LoginFooter';
import UpdateWhatsNewMessage from '../../components/UpdateWhatsNewMessage';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';
import { useHistory } from 'react-router-dom';

const UpdateWhatsNewMessagePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  const history = useHistory();

  useEffect(() => {
    if (role !== "admin") {
      history.push("/dashboard");
    }
  }, []);

  return (
    <>  
      <AdminHeader />
      <main>
        {role === "admin" && <UpdateWhatsNewMessage />}
      </main>
      <LoginFooter />
    </>
  )
}

export default UpdateWhatsNewMessagePage;